var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnRatingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 1.17532C12.3642 0.559335 13.2357 0.559337 13.4358 1.17532L15.4665 7.42503C15.735 8.25146 16.5051 8.81099 17.3741 8.81099H23.9454C24.5931 8.81099 24.8624 9.63979 24.3384 10.0205L19.0221 13.883C18.3191 14.3938 18.0249 15.2991 18.2934 16.1256L20.3241 22.3753C20.5242 22.9913 19.8192 23.5035 19.2952 23.1228L13.9789 19.2602C13.2759 18.7495 12.324 18.7495 11.621 19.2602L6.30466 23.1228C5.78067 23.5035 5.07565 22.9912 5.27579 22.3753L7.30645 16.1256C7.57497 15.2991 7.2808 14.3938 6.5778 13.883L1.26148 10.0205C0.737493 9.63979 1.00679 8.81099 1.65447 8.81099H8.2258C9.09476 8.81099 9.86489 8.25146 10.1334 7.42503L12.1641 1.17532Z",
    fill: "white",
    stroke: "#E6E6E6",
    strokeWidth: 1.33719
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnRatingIcon);
export default __webpack_public_path__ + "static/media/un-rating-icon.b6ae841af9ebfc8b9bcc9fb091c56365.svg";
export { ForwardRef as ReactComponent };